import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios, {AxiosResponse} from "axios";
import {RootState} from "../store";
import {toast} from "react-toastify";

export const fetchPosts = createAsyncThunk(
    "post/fetchPosts", async (_, thunkAPI) => {
        try {
            await thunkAPI.dispatch(clearPosts());
            const response: AxiosResponse = await axios.post("/api/post", {
                queryParams: {
                    orderBy: "last_updated",
                    order: "DESC"
                },
                returnValues: ["id", "title", "body", "created_in", "created_by", "last_updated", "last_updated_by"]
            });

            //const response: AxiosResponse = await axios.get("https://jsonplaceholder.typicode.com/posts");
            let posts: Post[] = response.data;
            let userIds: Array<number> = posts.map(post => post.created_by);
            userIds = [...new Set(userIds)];
            let usersInfo: any[] = [];
            await Promise.all(userIds.map(async userId => {
                const userResponse: AxiosResponse = await axios.post("/api/user", {
                    queryParams: {
                        id: userId
                    },
                    returnValues: ["id", "first_name", "last_name"]
                });
                usersInfo.push(userResponse.data);
                return userId;
            }));

            posts.map(post =>
                usersInfo.some(userInfo => {
                    if (post.created_by === userInfo.id) {
                        post.userInfo = userInfo;
                        return true
                    }
                    return false;
                })
            );
            return posts;
        } catch (error) {
            console.log(error)
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const fetchPostsByUserId = createAsyncThunk(
    "post/fetchPostsByUserId", async (userID: number, thunkAPI) => {
        try {
            await thunkAPI.dispatch(clearPosts());
            const postResponse: AxiosResponse = await axios.get(`https://jsonplaceholder.typicode.com/users/${userID}/posts`);
            const userResponse: AxiosResponse = await axios.get(`https://jsonplaceholder.typicode.com/users/${userID}`);
            let post: Post[] = postResponse.data;
            post.map(post => {
                post.userInfo = userResponse.data;
                return post;
            });

            return post;
        } catch (error) {
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const fetchCommentByPostId = createAsyncThunk(
    "post/fetchPostById", async (id: number, thunkAPI) => {
        try {
            await thunkAPI.dispatch(clearPosts());
            //const {post} = thunkAPI.getState() as { post: PostState };
            const response: AxiosResponse = await axios.get(`https://jsonplaceholder.typicode.com/posts/${id}/comments`);
            let selectedPost: Post;

            const postResponse: AxiosResponse = await axios.post("/api/post", {
                queryParams: {
                    whereClause: [{
                        key: "id",
                        value: id
                    }]
                },
                returnValues: ["id", "title", "body", "created_in", "created_by", "last_updated", "last_updated_by"]
            });
            if (postResponse.data.length > 0) {
                selectedPost = postResponse.data[0];
                const userResponse: AxiosResponse = await axios.post("/api/user", {
                    queryParams: {
                        whereClause: [{
                            key: "id",
                            value: selectedPost.created_by
                        }]
                    },
                    returnValues: ["id", "first_name", "last_name"]
                });
                selectedPost.userInfo = userResponse.data;

            } else {
                selectedPost = {} as Post;
            }
            return {
                comments: await response.data,
                post: selectedPost
            }
        } catch (error) {
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const addNewPost = createAsyncThunk(
    "post/addNewPost", async (values: { title: string, body: string }, thunkAPI) => {
        try {
            const response: AxiosResponse = await axios.post("/api/post/add", {
                data: {
                    title: values.title,
                    body: values.body
                }
            });

            if (response.status === 201) {
                return response.status;
            }
        } catch (error) {
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

type updatePostParams = {
    id: number,
    title: string,
    body: string,
    last_updated_by: number
};

export const updatePost = createAsyncThunk(
    "post/updatePost", async (values: updatePostParams, thunkAPI) => {
        try {
            const response: AxiosResponse = await axios.post("/api/post/update", {
                data: {
                    id: values.id,
                    title: values.title,
                    body: values.body,
                    last_updated_by: values.last_updated_by
                }
            });

            if (response.status === 200) {
                return response.status;
            }
        } catch (error) {
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const deletePost = createAsyncThunk(
    "post/deletePost", async (postId: number, thunkAPI) => {
        try {
            const response: AxiosResponse = await axios.post("/api/post/delete", {
                data: {
                    id: postId
                }
            });

            if (response.status === 200) {
                return response.status;
            }
        } catch (error) {
            let errorMessage: string = "An unexpected error occurred";
            if (axios.isAxiosError(error)) {
                errorMessage = error.message;
            }
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export type Post = {
    id: number
    title: string
    body: string
    last_updated: Date
    last_updated_by: number
    created_by: number
    created_in: Date
    userInfo: {
        id: number
        first_name: string
        last_name: string
    }
};

/**
 * all the comments of the given post
 */
export type Comment = {
    id: number
    postId: number
    name: string
    email: string
    body: string
};

// Define a type for the slice state
export type PostState = {
    post: {
        data: {
            posts: Post[]
            total: number
        }
        done: boolean
        error: string
    }
    postById: {
        data: {
            comments: Comment[]
            post: Post
        }
        done: boolean
        error: string
    }
};

// Define the initial state using that type
const initialState: PostState = {
    post: {
        data: {
            posts: [],
            total: 0
        },
        done: false,
        error: ""
    },
    postById: {
        data: {
            comments: [],
            post: {} as Post
        },
        done: false,
        error: ""
    }
};

export const postSlice = createSlice({
    name: "post",
    initialState,
    reducers: {
        clearPosts: () => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPosts.fulfilled, (state, action) => {
            return {
                ...state,
                post: {
                    ...state.post,
                    data: {posts: action.payload, total: action.payload.length},
                    done: true,
                    error: ""
                }
            };
        });
        builder.addCase(fetchPosts.rejected, (state, action) => {
            return {...state, post: {...state.post, done: true, error: (action.payload as string)}};
        });
        builder.addCase(fetchPosts.pending, (state) => {
            return {...state, post: {...state.post, done: false, error: ""}};
        });
        builder.addCase(fetchCommentByPostId.fulfilled, (state, action) => {
            return {
                ...state,
                postById: {
                    ...state.postById,
                    data: {comments: action.payload.comments, post: action.payload.post},
                    done: true,
                    error: ""
                }
            };
        });
        builder.addCase(fetchCommentByPostId.rejected, (state, action) => {
            return {...state, postById: {...state.postById, done: true, error: (action.payload as string)}};
        });
        builder.addCase(fetchCommentByPostId.pending, (state) => {
            return {...state, postById: {...state.postById, done: false, error: ""}};
        });
        builder.addCase(fetchPostsByUserId.fulfilled, (state, action) => {
            return {
                ...state,
                post: {
                    ...state.post,
                    data: {posts: action.payload, total: action.payload.length},
                    done: true,
                    error: ""
                }
            };
        });
        builder.addCase(fetchPostsByUserId.rejected, (state, action) => {
            return {...state, post: {...state.post, done: true, error: (action.payload as string)}};
        });
        builder.addCase(fetchPostsByUserId.pending, (state) => {
            return {...state, post: {...state.post, done: false, error: ""}};
        });
        builder.addCase(addNewPost.rejected, (state, action) => {
            return {...state, post: {...state.post, error: (action.payload as string)}};
        });
        builder.addCase(addNewPost.pending, (state) => {
            return {...state, post: {...state.post, error: ""}};
        });
        builder.addCase(updatePost.rejected, (state, action) => {
            return {...state, post: {...state.post, error: (action.payload as string)}};
        });
        builder.addCase(updatePost.pending, (state) => {
            return {...state, post: {...state.post, error: ""}};
        });
        builder.addCase(deletePost.rejected, (state, action) => {
            return {...state, post: {...state.post, error: (action.payload as string)}};
        });
        builder.addCase(deletePost.pending, (state) => {
            return {...state, post: {...state.post, error: ""}};
        });
    },
});

export const {clearPosts} = postSlice.actions;

export const getPosts = (state: RootState) => state.post.post;
export const getPostById = (state: RootState) => state.post.postById;

/*
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCount = (state: RootState) => state.counter.value;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd =
    (amount: number): AppThunk =>
        (dispatch, getState) => {
            const currentValue = selectCount(getState());
            if (currentValue % 2 === 1) {
                dispatch(incrementByAmount(amount));
            }
        };*/

export default postSlice.reducer;